import { AiChatConfig, AIGenerationType } from '../utils/ai-response-types.interface';

/**
 * Simplified AI Chat Configuration
 */
export const AI_CHAT_CONFIGS: Record<string, AiChatConfig> = {
  [AIGenerationType.DATA_MODEL]: {
    title: 'Create Data Model With AI',
    description: 'Describe the data structure you need for your application. AI will help you create a well-designed data model with proper fields, types, and relationships.',
    placeholder: 'Describe the data model you want to create (e.g., "Create a User model with name, email, phone fields and relation to Profile")',
    buttonText: 'Generate Data Models',
    saveButtonIcon: 'fa-solid fa-database',
    type: AIGenerationType.DATA_MODEL,
    imageUpload: true,
    redirectUrl: '/ai/generate-data-model'
  },

  [AIGenerationType.PAGE]: {
    title: 'Create Page With Assistant',
    description: 'Describe the page you want to build and AI Assistant will help you create it with the right components and layout.',
    placeholder: 'Describe the page you want to create (e.g., "Create a dashboard page with charts and user statistics")',
    buttonText: 'Generate Page',
    type: AIGenerationType.PAGE,
    imageUpload: false,
    redirectUrl: '/ai/generate-page'
  },

  [AIGenerationType.PAGE_LAYOUT]: {
    title: 'Create Page Layout With Assistant',
    description: 'Describe the page layout you want to create.',
    placeholder: 'Describe the page layout you want to create...',
    buttonText: 'Generate Page Layout',
    type: AIGenerationType.PAGE_LAYOUT,
    imageUpload: false,
    redirectUrl: '/ai/generate-page-layout'
  },

  [AIGenerationType.THEME]: {
    title: 'Create Theme With Assistant',
    description: 'Describe the visual style and theme you want for your application.',
    placeholder: 'Describe the theme you want to create (e.g., "Create a dark theme with blue accents and rounded corners")',
    buttonText: 'Generate Theme',
    type: AIGenerationType.THEME,
    imageUpload: false,
    redirectUrl: '/ai/generate-theme'
  },

  [AIGenerationType.ENDPOINT]: {
    title: 'Create API Endpoint With Assistant',
    description: 'Describe the API endpoint you want to create and its functionality.',
    placeholder: 'Describe the endpoint you want to create (e.g., "Create an endpoint for fetching user data by ID")',
    buttonText: 'Generate API Endpoint',
    type: AIGenerationType.ENDPOINT,
    imageUpload: false,
    redirectUrl: '/ai/generate-endpoint'
  },

  [AIGenerationType.COMPONENT]: {
    title: 'Create UI Component With Assistant',
    description: 'Describe the UI component you want to create and AI Assistant will help you design it with the right components and layout.',
    placeholder: 'Describe the component you want to create (e.g., "Create a button component with a label and an icon")',
    buttonText: 'Generate Component',
    type: AIGenerationType.COMPONENT,
    imageUpload: false,
    redirectUrl: '/ai/generate-component'
  },

  [AIGenerationType.ENTITY_COMPONENT]: {
    title: 'Design a Visual Element for the Entity Items',
    description: 'Create a reusable card that the AI will use to display your data. When you ask the AI about a specific item (like a patient, product, or task), it will use the component you design here. Describe how a single item should look and what actions it should have. e.g., A patient card with their name, photo, and primary diagnosis, with a button to "View Full Chart".',
    placeholder: 'Describe the entity component you want to create (e.g., "Create a card component for displaying patient information with name, photo, and diagnosis")',
    buttonText: 'Generate Entity Component',
    type: AIGenerationType.ENTITY_COMPONENT,
    imageUpload: true,
    redirectUrl: '/ai/generate-component'
  },

  [AIGenerationType.WORKFLOW]: {
    title: 'Create Workflow With Assistant',
    description: 'Describe the workflow you want to create and AI Assistant will help you design it with the right components and layout.',
    placeholder: 'Describe the workflow you want to create (e.g., "Create a workflow for user registration")',
    buttonText: 'Generate Workflow',
    type: AIGenerationType.WORKFLOW,
    imageUpload: false,
    redirectUrl: '/ai/generate-workflow'
  },

  [AIGenerationType.MESSAGE_TEMPLATE]: {
    title: 'Create Message Template With Assistant',
    description: 'Describe the message template you want to create and AI Assistant will help you design it with the right components and layout.',
    placeholder: 'Describe the message template you want to create (e.g., "Create a message template for user registration")',
    buttonText: 'Generate Message Template',
    type: AIGenerationType.MESSAGE_TEMPLATE,
    imageUpload: false,
    redirectUrl: '/ai/generate-message-template'
  },

  [AIGenerationType.DATA_STORE]: {
    title: 'Create Data Store With Assistant',
    description: 'Describe the data store you want to create and AI Assistant will help you design it with the right structure and relationships.',
    placeholder: 'Describe the data store you want to create (e.g., "Create a data store for user management with authentication")',
    buttonText: 'Generate Data Store',
    type: AIGenerationType.DATA_STORE,
    imageUpload: false,
    redirectUrl: '/ai/generate-data-store'
  }
};
